import { metrics, TheWestSection } from '@news-mono/component-library'
import { StaticRoutes, TogglesReduxState } from '@news-mono/web-common'
import { CheckedComponentInformation } from 'json-react-layouts'
import { layout } from '../../App.routing'
import { billboardLeaderboardMrec } from '../ad-units'
import { aflAndAflWSegment } from './afl-and-aflw'
import { brandContentSegment } from './brand-content-segment'
import { businessSegment } from './business-segment'
import { climateChangeSegment } from './climate-change-segment'
import { cnbcSegment } from './cnbc-segment'
import { coronavirusSegment } from './coronavirus-segment'
import { courtsCrimeSegment } from './courts_crime'
import { cricketSegment } from './cricket-segment'
import { entertaimentAndLifestyleSegment } from './entertainment-lifestyle-segment'
import { foodAndDrinkSegment } from './food-and-drink-segment'
import { getThemedSegment } from './get-themed-segment'
import { homeSegment } from './home-segment'
import { inCaseYouMissedItSegment } from './in-case-you-missed-it-segment'
import { indigenousAffairsSegment } from './indigenous-affairs'
import { jabTrackerSegment } from './jab-tracker-segment'
import { liveSportReplaysSegment } from './live-sport-replays'
import { liveSportSegment } from './live-sport-segment'
import { miscCollectionsSegment } from './misc-collections-segment'
import { moreSportSegment } from './more-sport-segment'
import { opinionSegment } from './opinion-segment'
import { politicsSegment } from './politics-segment'
import { propertySegment } from './property-segment'
import { regionalSegment } from './regional-segment'
import { subscriberExclusive } from './subscriber-exclusive'
import { telethonCountdown } from './telethon-countdown'
import { travelSegment } from './travel-segment'
import { upLateSegment } from './up-late-segment'
import { worldSegment } from './world-segment'
import { yourMoneySegment } from './your-money-segment'

const rampAdUnit = layout.component({
    type: 'ad-unit',
    props: {
        noticePosition: 'below-center',
        hiddenUntilLoaded: true,
        padding: [0, 0, metrics.thewest.margins.lg, 0],
        slot: {
            id: 'ramp',
            size: 'ramp',
            exclusionLabels: ['NoAds'],
        },
    },
})

export const homepage: StaticRoutes<TheWestSection> = {
    '': ({ getAdTargeting, store, config }) => ({
        kind: 'page',
        heading: 'The West Australian | Perth, WA, National & World News',
        pageType: 'homepage',
        hideHeading: true,
        refreshOnInactive: true,
        noMetaTitleTemplate: true,
        pageMeta: {
            title: 'The West Australian | Perth, WA, National & World News',
            description:
                'The West Australian is a leading news source in Perth and WA. Breaking local and world news from sport and business to lifestyle and current affairs.',
        },
        adTargeting: getAdTargeting('home', 'default', 'home'),
        section: 'default',

        compositions: [
            mainContentSection(store.getState().toggles, [
                getThemedSegment({
                    featureToggle: 'queens-legacy-home',
                    layoutVersion: '9-card',
                    curation: 'queens-legacy',
                    themeOverride: 'queens-legacy',
                }),
                liveSportSegment(),
                jabTrackerSegment({ contentApi: config.contentApi }),
                coronavirusSegment,
                telethonCountdown,
                ...upLateSegment,
                rampAdUnit,
                subscriberExclusive(),
                ...businessSegment(store),
                cnbcSegment(),
                inCaseYouMissedItSegment(store.getState().render.renditionType),
                ...billboardLeaderboardMrec('one'),
                courtsCrimeSegment,
                politicsSegment,
                climateChangeSegment,
                entertaimentAndLifestyleSegment,
                ...billboardLeaderboardMrec('two'),
                ...cricketSegment,
                aflAndAflWSegment,
                liveSportReplaysSegment,
                moreSportSegment,
                indigenousAffairsSegment,
                ...billboardLeaderboardMrec('three'),
                opinionSegment,
                worldSegment,
                yourMoneySegment,
                propertySegment,
                foodAndDrinkSegment,
                ...brandContentSegment,
                regionalSegment,
                ...travelSegment,
                miscCollectionsSegment,
            ]),
            layout.composition({
                type: 'thor',
                props: {
                    hasBackgroundFill: false,
                    containerWidth:
                        metrics.thewest.siteMetrics.mainContentWidth,
                    horizontalGutters: 'outerMargin',
                    verticalGutters: 'xl',
                },
                contentAreas: {
                    main: [
                        layout.component({
                            type: 'taboola',
                            props: {
                                taboolaContainerId:
                                    'taboola-below-home-thumbnails',
                                locationType: 'home',
                            },
                        }),
                    ],
                },
            }),
        ],
    }),
}

function mainContentSection(
    toggleValues: TogglesReduxState,
    components: Array<CheckedComponentInformation>,
) {
    return layout.composition({
        type: 'thor',
        props: {
            hasBackgroundFill: false,
            containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
            horizontalGutters: false,
            verticalGutters: false,
        },
        contentAreas: {
            main: [
                homeSegment(toggleValues),
                layout.nestedComposition({
                    type: 'thor',
                    props: {
                        hasBackgroundFill: true,
                        containerWidth: '100%',
                        verticalGutters: false,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: components,
                    },
                }),
            ],
        },
    })
}
